import React from 'react'
import EffConfigCard, { FieldRow, BoolBadge, NumericValue } from './EffConfigCard'
import { LuminaireEffectiveDimming, LuminaireEffectiveHealth } from '../../types/luminaire.types'

// Santé: comms/health flags + MCU temperature, plus the folded-in driver/lamp
// status from the dimming source.
export default function SanteCard({
  dimming,
  health,
  tooltip,
}: {
  dimming: LuminaireEffectiveDimming | null
  health: LuminaireEffectiveHealth | null
  tooltip?: string
}) {
  return (
    <EffConfigCard title="Santé" tooltip={tooltip}>
      <FieldRow label="Lampe allumée">
        <BoolBadge value={dimming?.lamp_on ?? null} />
      </FieldRow>
      <FieldRow label="Défaut lampe">
        <BoolBadge value={dimming?.lamp_failure ?? null} okWhenTrue={false} />
      </FieldRow>
      <FieldRow label="Erreur driver">
        <BoolBadge value={dimming?.driver_error ?? null} okWhenTrue={false} />
      </FieldRow>
      <FieldRow label="Fade en cours">
        <BoolBadge value={dimming?.fade_running ?? null} />
      </FieldRow>
      <FieldRow label="Err. conn. DALI">
        <BoolBadge value={health?.dali_connection_error ?? null} okWhenTrue={false} />
      </FieldRow>
      <FieldRow label="Err. com. RTC">
        <BoolBadge value={health?.rtc_com_error ?? null} okWhenTrue={false} />
      </FieldRow>
      <FieldRow label="Err. métrologie">
        <BoolBadge value={health?.metering_com_error ?? null} okWhenTrue={false} />
      </FieldRow>
      <FieldRow label="LumaLink connecté">
        <BoolBadge value={health?.lumalink_connected ?? null} okWhenTrue={true} />
      </FieldRow>
      <FieldRow label="LumaLink vu 1x">
        <BoolBadge value={health?.lumalink_connected_once ?? null} />
      </FieldRow>
      <FieldRow label="Temp. MCU">
        <NumericValue value={health?.mcu_temperature_c ?? null} unit="°C" />
      </FieldRow>
    </EffConfigCard>
  )
}
